
    import TeamMemberCard from './TeamMemberCard.vue';

    export default {
        components: {
            TeamMemberCard,
        },
        data() {
            return {
                selectedCategory: '',
                isFilterScrolledToLeft: true,
                teamCategories: [],
                teamMembers: [],
            };
        },
        computed: {
            filteredTeamMembers() {
                return this.teamMembers.filter(
                    (teamMember) => (teamMember.acf.category === this.selectedCategory),
                );
            },
        },
        created() {
            this.getTeamMembers();
        },
        mounted() {
            document.getElementById('filter-wrapper')
                .addEventListener('scroll', this.onFilterScroll);
        },
        methods: {
            getTeamMembers() {
                this.$getDataFromCache(`/wp-json/wp/v2/team?per_page=100`)
                    .then((response) => {
                        this.teamMembers = response.data.reverse();
                        this.setTeamCategories(this.teamMembers);
                    });
            },
            setTeamCategories(teamMembers) {
                const allCategories = teamMembers.map((teamMember) => teamMember.acf.category);
                this.teamCategories = [...new Set(allCategories)];
                this.selectedCategory = this.teamCategories[0];
            },
            scrollLeft() {
                const filter = document.getElementById('filter-wrapper');
                filter.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                });
            },
            scrollRight() {
                const filter = document.getElementById('filter-wrapper');
                filter.scroll({
                    top: 0,
                    left: 1000,
                    behavior: 'smooth',
                });
            },
            onFilterScroll() {
                const filter = document.getElementById('filter-wrapper');
                this.isFilterScrolledToLeft = filter.scrollLeft === 0;
            },
            setSelectedCategory(category) {
                this.selectedCategory = category;
            },
        },
    };
